<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import {
  MASIFI_WA_KIND_SETTING,
  MASIFI_WA_KINDS,
  isMasifiWaQrEnabled,
  masifiWaSavedKind,
} from 'dashboard/helper/masifi/masifiWaGroups';

// "Todas · Personas · Grupos" (spec F3 §6.1, ruling 9; E2E fix batch 5 item 6, decisión de Marcos 2026-09-24): chips
// VISIBLES arriba de la lista, como los filtros de WhatsApp (antes era "Tipo", escondido dentro del desplegable
// "Ordenar conversaciones"). La elección vive en el ui_settings NATIVO del usuario y el servidor la aplica antes de los
// conteos (Groups::KindFilter); al cambiar, ChatList recarga lista + pestañas (resetAndFetchData). Segmentado nativo
// (TabBar). Solo con el módulo WhatsApp QR entregado a la cuenta. Es la ÚNICA forma de ver solo grupos: la vista
// "Grupos" del sidebar se retiró (E2E fix batch 7, decisión de Marcos 2026-09-24).
const emit = defineEmits(['change']);

const { t } = useI18n();
const store = useStore();
const { uiSettings } = useUISettings();

const isVisible = computed(() => isMasifiWaQrEnabled(store.getters));
const current = computed(() =>
  masifiWaSavedKind(store.getters, uiSettings.value)
);
const LABELS = {
  all: 'MASIFI_WHATSAPP_QR.GROUPS.KIND_FILTER.ALL',
  individual: 'MASIFI_WHATSAPP_QR.GROUPS.KIND_FILTER.INDIVIDUAL',
  group: 'MASIFI_WHATSAPP_QR.GROUPS.KIND_FILTER.GROUP',
};
const tabs = computed(() =>
  MASIFI_WA_KINDS.map(value => ({ value, label: t(LABELS[value]) }))
);
const activeIndex = computed(() =>
  Math.max(MASIFI_WA_KINDS.indexOf(current.value), 0)
);

const onTabChanged = async ({ value }) => {
  if (value === current.value) return;
  await store.dispatch('updateUISettings', {
    uiSettings: { ...uiSettings.value, [MASIFI_WA_KIND_SETTING]: value },
  });
  emit('change', value);
};
</script>

<template>
  <div
    v-if="isVisible"
    data-test="masifi-wa-kind-chips"
    class="px-3 pb-2 overflow-x-auto"
  >
    <TabBar
      :tabs="tabs"
      :initial-active-tab="activeIndex"
      @tab-changed="onTabChanged"
    />
  </div>
</template>
